import { initGraphQLTada } from 'gql.tada'
import type { introspection } from '../graphql-env.d.ts'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    ID: string
    String: string
    Boolean: boolean
    Int: number
    Float: number
    DateTime: string
    ISO8601DateTime: string
    JSON: Record<string, any>
  }
}>()

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada'
export { readFragment } from 'gql.tada'
